import { z } from 'zod';
import { encryptedKeyByRsaKeyValidator, publicKeyValidator, signedEntityByRsaKeyValidator, } from '#validation';
export const CommonMemberCryptoSchema = z.object({
    publicKey: publicKeyValidator,
    ePrivateKeyByInvitationKey: encryptedKeyByRsaKeyValidator,
    eInvitationPrivateKeyByMemberKey: encryptedKeyByRsaKeyValidator,
    sMemberByInvitationKey: signedEntityByRsaKeyValidator,
});
